import { Node } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";

import { VarChip } from "./VarChip.js";

/**
 * Atomic inline `{{…}}` variable chip. `atom: true` makes it indivisible — one
 * backspace removes the whole chip, never half a token. A React NodeView
 * (VarChip) renders the human label resolved from context; `renderText` keeps
 * the raw token so copy-as-text and serialization stay lossless.
 *
 * Schema-local: the node name only exists inside an editor instance, so it does
 * not collide with the prompt editor's own `varToken` node.
 */
export const VarTokenNode = Node.create({
  name: "varToken",
  group: "inline",
  inline: true,
  atom: true,
  selectable: true,

  addAttributes() {
    return { token: { default: "" } };
  },

  parseHTML() {
    return [{ tag: "span[data-var-token]" }];
  },

  renderHTML({ HTMLAttributes }) {
    return ["span", { ...HTMLAttributes, "data-var-token": "" }];
  },

  renderText({ node }) {
    return node.attrs.token as string;
  },

  addNodeView() {
    return ReactNodeViewRenderer(VarChip);
  },
});
